import {
  EVENTS_CATEGORY,
  EVENTS_INTERACTIONS,
  EVENT_ACTIONS
} from '../modules/app/services/datahub/constants';
import DatahubService from '../modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from '../modules/app/services/datahub/helper';

export const sendEvent = (label, url) => {
  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      action: EVENTS_INTERACTIONS.CLICK,
      category: EVENTS_CATEGORY.MEMBERSHIP_BANNER,
      label,
      url
    })
  });
};
